import React from "react";
import {observer} from "mobx-react-lite";
import {useNavigate} from "react-router-dom";

import appStore from "../../../../storage/AppStore";
import PageLayout from "../../../PageLayout";


const ROLE_BUTTONS = [
    {
        role: "MMBR",
        path: "member",
        icon: "pi pi-user",
    },
    {
        role: "PRNT",
        path: "parent",
        icon: "pi pi-users",
    },
    {
        role: "MGR",
        path: "staff/MGR",
        icon: "pi pi-briefcase",
    },
    {
        role: "TRN",
        path: "staff/TRN",
        icon: "pi pi-star",
    },
    {
        role: "MDC",
        path: "staff/MDC",
        icon: "pi pi-heart",
    },
    {
        role: "SMM",
        path: "staff/SMM",
        icon: "pi pi-megaphone",
    },
];


const NewCompanyUserType = () => {
    const navigate = useNavigate();

    const getRoleName = (roleId) => {
    return (
        appStore.rolesLocalized?.find(
            (role) => role.id === roleId
        )?.name ||
        roleId
    );
};

    return (
        <PageLayout
            header={
                <div className="col-12">
                    <h3 className="m-0">
                        {appStore.tr.add_member}
                    </h3>
                </div>
            }
        >
            <div className="choice-grid">

                {ROLE_BUTTONS.map((item) => (
                    <button
                        key={item.role}
                        type="button"
                        className="choice-tile"
                        onClick={() => {
                            navigate(
                                `/manager/member/new/${item.path}`
                            );
                        }}
                    >
                        <span className="choice-tile__icon">
                            <i className={item.icon}/>
                        </span>

                        <span className="choice-tile__title">
                            {getRoleName(item.role)}
                        </span>
                    </button>
                ))}

            </div>
        </PageLayout>
    );
};


export default observer(NewCompanyUserType);